module.exports = __webpack_public_path__ + "static/media/illustration-07.05237762.png";